import { useState } from "react";
import { subscribeNewsletter } from "@/lib/api";

export default function JournalSubscribe() {
  const [first, setFirst] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      await subscribeNewsletter(email);
      setStatus("done");
    } catch { setStatus("error"); }
  };

  return (
    <aside
      data-testid="journal-subscribe"
      className="mt-24 border-t border-[#D5CDBF] pt-16"
    >
      <div className="max-w-[640px] mx-auto text-center">
        <div className="label-eyebrow">Continue the Conversation</div>
        <h2 className="serif mt-8 text-[30px] sm:text-[40px] leading-[1.1]">
          Join the Studio A Journal.
        </h2>
        <div className="mt-10 space-y-5 text-[16px] leading-[1.85] text-[#55524C]">
          <p>If something in today's Journal resonated with you, I'd love to continue sharing these thoughts with you.</p>
          <p>Occasional reflections on skin, nervous system health and everyday wellbeing.</p>
          <p className="serif italic text-[17px]">No algorithms. No pressure. Just meaningful writing whenever there's something worth sharing.</p>
        </div>

        {status !== "done" ? (
          <form onSubmit={submit} data-testid="journal-subscribe-form" className="mt-12 space-y-5 max-w-md mx-auto text-left">
            <div>
              <label className="label-eyebrow" htmlFor="js-first">First name</label>
              <input id="js-first" required minLength={2} data-testid="journal-subscribe-first"
                className="input-soft" value={first} onChange={(e) => setFirst(e.target.value)} />
            </div>
            <div>
              <label className="label-eyebrow" htmlFor="js-email">Email address</label>
              <input id="js-email" type="email" required data-testid="journal-subscribe-email"
                className="input-soft" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <button type="submit" data-testid="journal-subscribe-submit"
              disabled={status === "loading"}
              className="btn-primary w-full justify-center mt-6">
              {status === "loading" ? "Sending…" : "Join the Journal"}
            </button>
          </form>
        ) : (
          <p className="serif italic mt-12 text-[22px] text-[#2E2B27]" data-testid="journal-subscribe-done">
            Thank you{first ? `, ${first}` : ""}. I'll write when there's something worth sharing.
          </p>
        )}
      </div>
    </aside>
  );
}
